import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import store from './store';
import { DatadogLogger } from './shared/helpers/datadog-logger.helper';
import { installGetUserMediaDevToolsFallback } from './shared/helpers/getUserMedia-devtools-fallback.helper';
import { registerIncodeSdkServiceWorker } from './serviceWorkerRegistration';

installGetUserMediaDevToolsFallback();

if (
  process.env.REACT_APP_DATADOG_LOGGING_ENABLED === 'true' &&
  process.env.NODE_ENV === 'production'
) {
  DatadogLogger.Initialize(
    process.env.REACT_APP_DATADOG_TOKEN ?? '',
    process.env.REACT_APP_DATADOG_SITE ?? 'datadoghq.com',
    process.env.REACT_APP_DATADOG_SERVICE ?? 'liveness-app',
    process.env.NODE_ENV,
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <App />
      </CookiesProvider>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
registerIncodeSdkServiceWorker();
